import commonConfig, {envri} from '../../common/main/config';

export default {
	envri: envri,
	cpmetaObjectUri: commonConfig.cpmetaObjectUri,
	sparqlEndpoint: commonConfig.sparqlEndpoint,
	pagesize: 100
}